<h2 class="main-title text-center">{{ 'CUSTOMIZATION.SOCKS.TITLE' | translate }}</h2>

<div class="row m-0 my-5 align-items-center justify-content-center">
  <div class="col-12 col-md-6 svg-container">
    <div class="svg-logo">
      <div inlineSVG="assets/img/customize/socks.svg" #svgContainer></div>
    </div>
  </div>

  <div class="col-12 col-md-6 mt-4 mt-md-0 px-4">
    <div class="card p-4">
      <!-- Top -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.SOCKS.TOP' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-socksTop'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: socksSelections.topColor === color }"
            (click)="setTopColor(color)"></span>
        </div>
        <div *ngIf="hasError('SOCKS.TOP_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SOCKS_TOP_COLOR_REQUIRED' | translate }}
        </div>
        
      </div>

      <!-- Logo -->
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.SOCKS.LOGO' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-socksLogo'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: socksSelections.logoColor === color }"
            (click)="setLogoColor(color)"></span>
        </div>
        <div *ngIf="hasError('SOCKS.LOGO_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SOCKS_LOGO_COLOR_REQUIRED' | translate }}
        </div>

      </div>

      <!-- Bottom -->
      <div class="mb-2">
        <label class="form-label">{{ 'CUSTOMIZATION.SOCKS.BOTTOM' | translate }}</label>
        <div class="d-flex flex-wrap gap-2">
          <span [id]="color + '-socksBottom'" *ngFor="let color of colors" [ngStyle]="{ background: color }"
            class="color-circle" [ngClass]="{ active: socksSelections.bottomColor === color }"
            (click)="setBottomColor(color)"></span>
        </div>
        <div *ngIf="hasError('SOCKS.BOTTOM_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SOCKS_BOTTOM_COLOR_REQUIRED' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>